import React from 'react';
import { Box, Typography, useTokens } from '@barracuda-internal/bds-core';

/**
 * Placeholder for routes wired into the nav but not yet implemented.
 * Pass a `title` and optional `description`. Phase 2 replaces these with
 * real list/CRUD pages.
 */
const ComingSoonPage = ({ title, description }) => {
  const tokens = useTokens();
  return (
    <Box sx={{ padding: tokens.aliasesSpaceContainerSpacious }}>
      <Typography
        variant="h2"
        sx={{ marginBottom: tokens.aliasesSpaceContainerDefault }}
      >
        {title}
      </Typography>
      <Typography variant="body1" sx={{ maxWidth: 500 }}>
        {description ||
          'This view is part of the next phase and will be available shortly.'}
      </Typography>
    </Box>
  );
};

export default ComingSoonPage;
